import { memo } from 'react';
import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';
import clsx from 'clsx';

// Import FuseScrollbars first, before using it in styled
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import Navigation from '@/components/theme-layouts/components/navigation/Navigation';
import UserMenu from '@/components/theme-layouts/components/UserMenu';
import NavbarPinToggleButton from '@/components/theme-layouts/components/navbar/NavbarPinToggleButton';
import Logo from '../../../../components/Logo';
import GoToDocBox from '@/components/theme-layouts/components/GoToDocBox';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  '& ::-webkit-scrollbar-thumb': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.24)' : 'rgba(255, 255, 255, 0.24)'
    }`
  },
  '& ::-webkit-scrollbar-thumb:active': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.37)' : 'rgba(255, 255, 255, 0.37)'
    }`
  }
}));

// Move StyledContent definition after FuseScrollbars import
const StyledContent = styled(FuseScrollbars)({
  overscrollBehavior: 'contain',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 40px, 100% 10px',
  backgroundAttachment: 'local, scroll'
});

type NavbarStyle2ContentProps = {
  className?: string;
};

function NavbarStyle2Content(props: NavbarStyle2ContentProps) {
  const { className = '' } = props;

  return (
    <Root className={clsx('flex h-full flex-auto flex-col overflow-hidden', className)}>
      <div className="flex h-48 shrink-0 flex-row items-center px-12 md:h-76 gap-6">
        <Logo />
        <NavbarPinToggleButton className="h-32 w-32 p-0" />
      </div>

      <StyledContent
        className="flex min-h-0 flex-1 flex-col"
        option={{ suppressScrollX: true, wheelPropagation: false }}
      >
        <Navigation layout="vertical" />
      </StyledContent>

      <GoToDocBox className="mx-12 my-16" />
      <Divider />

      <div className="p-4 md:p-10 w-full">
        <UserMenu className="w-full" />
      </div>
    </Root>
  );
}

export default memo(NavbarStyle2Content);
